import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { getCurrentUser, selectUser, selectAuthLoading, selectAuthError } from "../store/slices/authSlice";
import ModuleDashboard from "../components/dashboard/ModuleDashboard";

export default function Dashboard() {
  const dispatch = useAppDispatch();
  
  const user = useAppSelector(selectUser);
  const loading = useAppSelector(selectAuthLoading);
  const error = useAppSelector(selectAuthError);

  useEffect(() => {
    if (!user) {
      dispatch(getCurrentUser());
    }
  }, [dispatch, user]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-center">
          <div className="mx-auto mb-4 w-8 h-8 rounded-full border-4 border-emerald-600 animate-spin border-t-transparent"></div>
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-center">
          <AlertTriangle size={48} className="mx-auto mb-4 text-red-500" />
          <h3 className="mb-2 text-lg font-medium text-gray-900">Error Loading Dashboard</h3>
          <p className="text-gray-500">{error}</p>
        </div>
      </div>
    );
  }

  // Render module-aware dashboard
  return <ModuleDashboard />;
}
